<div class="relative overflow-x-auto py-4">
  <h1 class="text-2xl font-semibold text-gray-800 dark:text-white py-4">
    User List
  </h1>
  <div>
    <app-user-filter/>
  </div>
  <div class="flex justify-end py-4">
    <a
      routerLink="/user/create"
      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    >
      Create User
    </a>
  </div>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
      <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
              <th scope="col" class="px-6 py-3">
                  Id
              </th>
              <th scope="col" class="px-6 py-3">
                  Name
              </th>
              <th scope="col" class="px-6 py-3">
                  Email
              </th>
              <th scope="col" class="px-6 py-3">
                  Action
              </th>
          </tr>
      </thead>
      <tbody>
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200"
            *ngFor="let user of users"
          >
              <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {{user.id}}
              </th>
              <td class="px-6 py-4">
                  {{user.name}}
              </td>
              <td class="px-6 py-4">
                  {{user.email}}
              </td>
              <td class="px-6 py-4">
                <a routerLink="/user/{{user.id}}/edit">
                  edit
                </a>

              </td>
          </tr>

      </tbody>
  </table>
</div>
